import { render, staticRenderFns } from "./FullscreenPoster.vue?vue&type=template&id=8402f906&scoped=true"
import script from "./FullscreenPoster.vue?vue&type=script&lang=js"
export * from "./FullscreenPoster.vue?vue&type=script&lang=js"
import style0 from "./FullscreenPoster.vue?vue&type=style&index=0&id=8402f906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8402f906",
  null
  
)

export default component.exports